import { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { NavigateLinks, LoaderBackdrop } from '@/components';
import { routeDetailBreadcrumbs } from '../config';
import { RouteDetail } from '../components';
import { useRouteDetail } from '../hooks';

const RouteDetailPage = () => {
  const { routeId } = useParams<{ routeId: string }>();
  const navigate = useNavigate();

  const breadcrumbs = useMemo(
    () => (routeId ? routeDetailBreadcrumbs(navigate, routeId) : []),
    [navigate, routeId]
  );

  const { routeDetail, isLoading, error } = useRouteDetail({
    routeId: routeId || '',
    skip: !routeId,
  });

  if (isLoading) {
    return (
      <section className='flex flex-col gap-6 w-full h-full relative'>
        <NavigateLinks actualPage='Detalle de Ruta' breadcrumbs={breadcrumbs} />
        <LoaderBackdrop />
        <div className='text-center text-gray-500 py-8'>Cargando ruta...</div>
      </section>
    );
  }

  if (error || !routeDetail) {
    return (
      <section className='flex flex-col gap-6 w-full h-full'>
        <NavigateLinks actualPage='Detalle de Ruta' breadcrumbs={breadcrumbs} />
        <div className='text-center py-8'>
          <p className='text-red-600 font-medium'>
            No se pudo cargar la ruta
          </p>
          <p className='text-gray-600 mt-2'>
            La ruta no existe o hubo un error al obtener los datos. Volvé al listado e intentá de nuevo.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks actualPage='Detalle de Ruta' breadcrumbs={breadcrumbs} />
      <RouteDetail routeDetail={routeDetail} routeId={routeId || ''} />
    </section>
  );
};

export default RouteDetailPage;

